import ImageSlider from './ImageSlider'; 


import ScineceLab1 from '../assets/images/facilities/Science/01.jpg';
import ScineceLab2 from '../assets/images/facilities/Science/02.jpg';
import ScineceLab3 from '../assets/images/facilities/Science/03.jpg';
import ScineceLab4 from '../assets/images/facilities/Science/04.jpg';
import ScineceLab5 from '../assets/images/facilities/Science/05.jpg';


const images = [
    { src: ScineceLab1, altText: 'Scinece Lab-1' },
    { src: ScineceLab2, altText: 'Scinece Lab-2' },
    { src: ScineceLab3, altText: 'Scinece Lab-3' },
    { src: ScineceLab4, altText: 'Scinece Lab-4' },
    { src: ScineceLab5, altText: 'Scinece Lab-5' },
];
const ScienceLab = () => {
    return (
        <section className="ftco-section ftco-no-pt ftco-no-pb"> 
            <div className="container">
                <div className="row justify-content-center mt-3 pb-4">
                    <div className="col-md-12 heading-section ftco-animate text px-4">
                        <h2 className="mb-4 text-success text-center">
                        🔬 Science Lab
                        </h2>   
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col-md-8 order-md-first">
                        <div className="text px-4">
                            <p>
                                The Science Lab at SRN is a well-equipped learning space where students explore and experiment with concepts in Physics, Chemistry, and Biology. It provides hands-on experience that enhances theoretical knowledge and fosters a spirit of scientific inquiry.   </p>
                            <p>
                            🌟 Key Features of the Science Lab:<br/>

✅ Modern Equipment & Apparatus – Tools for physics experiments, chemistry reactions, and biological studies.<br/>
✅ Safe & Well-Ventilated Environment – Equipped with fire extinguishers, fume hoods, and first-aid kits.<br/>
✅ Interactive Learning – Practical experiments to reinforce classroom learning.<br/>
✅ Microscopes & Specimens – Advanced equipment for biological studies.<br/>
✅ Chemical Solutions & Reagents – Safe and labeled chemicals for conducting chemistry experiments.<br/><br/>

🧪 Experiments Conducted in the Science Lab:<br/>

🔹 Physics – Mechanics, optics, electricity, magnetism, and thermodynamics experiments.<br/>
🔹 Chemistry – Acid-base reactions, titration, chemical bonding, and laboratory synthesis.<br/>
🔹 Biology – Microscopic studies, cell structure observation, plant and animal dissections, and DNA extraction.<br/><br/>

⚠️ Lab Safety Rules:<br/>

📍 Always wear lab coats and safety goggles.<br/>
📍 Handle glassware, chemicals, and equipment with care.<br/>
📍 Follow teacher instructions while conducting experiments.<br/>
📍 Clean up the workspace after experiments.<br/>
📍 Report any spills or accidents immediately.<br/>

The Science Lab is an integral part of our curriculum, helping students develop critical thinking, problem-solving, and analytical skills through real-world applications of science.<br/>

📍 Location: Science Lab Block <br/>
🕒 Timings: 9 A.M - 3 P.M<br/>
📞 Contact: Lab Instructor <br/>

We encourage all students to actively participate in lab activities and make the most of this exciting learning environment!
                            </p>
                         </div>
                    </div>
                    <div className=" col-md-4 order-md-first wrap-about">
                    <ImageSlider images={images} />              
                    </div>
                     
                </div>  
            </div>
            <hr className="custom-hr"/>
        </section>
    );
};

export default ScienceLab;
